import React, { useEffect, useRef, useState } from 'react';
import Img from './Img';

const GAL = [
  {f:'IMG_9835'},{f:'IMG_0002'},{f:'IMG_9789'},{f:'IMG_9404'},
  {f:'IMG_9385'},{f:'IMG_0626'},{f:'IMG_0594'},{f:'IMG_0456'},{f:'IMG_0442'},
];

export default function Gallery() {
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);

  function setGal(i) {
    const next = ((i % GAL.length) + GAL.length) % GAL.length;
    setIdx(next);
    clearInterval(timer.current);
    timer.current = setInterval(() => setIdx(prev => (prev + 1) % GAL.length), 4800);
  }

  useEffect(() => {
    timer.current = setInterval(() => setIdx(prev => (prev + 1) % GAL.length), 4800);
    return () => clearInterval(timer.current);
  }, []);

  const navBtn = (dir) => ({
    position:'absolute', top:'50%', transform:'translateY(-50%)', [dir === 'prev' ? 'left' : 'right']:14,
    width:46, height:46, borderRadius:'50%', border:'1.5px solid rgba(255,255,255,.55)',
    background:'rgba(46,28,36,.32)', backdropFilter:'blur(6px)', color:'#fff', fontSize:22,
    display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', padding:0, zIndex:2,
  });

  return (
    <section id="gallery" style={{ padding:'30px 0 86px' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px' }}>
        <div style={{ textAlign:'center', maxWidth:620, margin:'0 auto 44px' }}>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', justifyContent:'center', gap:9 }}>
            The gallery
          </span>
          <h2 style={{ fontSize:'clamp(2.3rem,4.4vw,3.4rem)', margin:'12px 0 12px' }}>Stories we've iced</h2>
          <p style={{ color:'var(--ink-2)', fontSize:18, margin:0 }}>Real cakes, real messages. Find a feeling and then tell us yours.</p>
        </div>
        <div style={{ position:'relative', maxWidth:900, margin:'0 auto' }}>
          <div style={{ position:'relative', borderRadius:24, overflow:'hidden', boxShadow:'var(--shadow)', aspectRatio:'4/3', background:'var(--blush-deep)' }} className="kt-rstage">
            {GAL.map(({f}, i) => (
              <Img key={f} src={`/assets/cakes/${f}.jpeg`} alt="Kreme Tops cake"
                loading={i === 0 ? 'eager' : 'lazy'}
                style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', opacity: i === idx ? 1 : 0, transition:'opacity .8s ease' }} />
            ))}
            <button style={navBtn('prev')} onClick={() => setGal(idx - 1)} aria-label="Previous">‹</button>
            <button style={navBtn('next')} onClick={() => setGal(idx + 1)} aria-label="Next">›</button>
          </div>
        </div>
      </div>
      <style>{`@media(max-width:560px){ .kt-rstage{aspect-ratio:1/1!important;} }`}</style>
    </section>
  );
}
